import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useStatusContext } from '../context/StatusContext';
import { useRolesContext } from '../context/RolesContext';
import { useEffect } from 'react';
import { useUserContext } from '../context/UserContext';
import ColorPicker from 'react-pick-color'

const ModalCreatetState = ({ onClose, object }) => {
  const { addStatus, editStatus, deleteState } = useStatusContext();
  const { roles } = useRolesContext();
  const { roleId} = useUserContext();
  const [name, setName] = useState(object?object.name:'');
  const [color, setColor] = useState(object?object.color:'');
  const [roleType, setRoleType] = useState(null)

   useEffect(()=>{
        if (roles){
          let idx = roles.findIndex((r)=>{return r._id===roleId});
          if (idx !== -1){
            setRoleType(roles[idx].type)
          }
        }
      }, [roles])

  // Обработчик сохранения комментария
  const handleSave = () => {
    if (object) {
        editStatus(({name, color}), object._id)
    } else {
        addStatus({name, color })
    }
      onClose();
  };
 const handleDelete = () => {
    deleteState(object._id);
    onClose();
  }
  // Обработчик закрытия окна
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="task-modal admin-modal admin-modal--narrow">
        <header className="task-modal__header">
          <h2 className="task-modal__title">
            {!object ? 'Создание состояния' : 'Редактирование состояния'}
          </h2>
          <button className="task-modal__close" onClick={handleClose}>×</button>
        </header>

        <div className="task-modal__body">
          <div className="admin-modal__grid">
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label" htmlFor="name">Название</label>
              <input
                className="admin-modal__input"
                id="name"
                required
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label" htmlFor="color">Цвет</label>
              <div className="admin-modal__color-preview" style={{ background: color || '#e5e7eb' }} />
              <ColorPicker
                id="color"
                required
                color={color}
                onChange={e => setColor(e.hex)}
              />
            </div>
          </div>
        </div>

        <footer className="task-modal__footer">
          <button className="task-modal__btn task-modal__btn--ghost" onClick={handleClose}>Отмена</button>
          <button className="task-modal__btn task-modal__btn--primary" onClick={handleSave}>Сохранить</button>
          {(roleType === 'firstAdmin' || roleType === 'admin') && object && (
            <button className="task-modal__btn task-modal__btn--danger" onClick={handleDelete}>Удалить</button>
          )}
        </footer>
      </div>
    </div>
  );
};

// Пропсы, обязательные для корректной работы
ModalCreatetState.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ModalCreatetState;